import { useEffect, useState } from 'react';

interface NavbarProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
}

export default function Navbar({ activeSection, setActiveSection }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(id);
    }
  };

  const navItems = [
    { id: 'hero', label: 'HOME' },
    { id: 'news', label: 'NEWS' },
    { id: 'business', label: 'BUSINESS' },
    { id: 'services', label: 'SERVICES' },
    { id: 'gallery', label: 'GALLERY' },
    { id: 'contact', label: 'CONTACT' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/6902dd986b6e328bf9bb68047035d84f/5fb36d5e9028b47c0fac686a51ca35fe.png" 
              alt="NACHTEULE CREATION" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-bold tracking-wider">NACHTEULE CREATION</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm font-medium tracking-wide transition-colors duration-300 hover:text-purple-400 whitespace-nowrap cursor-pointer ${
                  activeSection === item.id ? 'text-purple-400' : 'text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <button className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
